import "./DetailCard.css";
import React from 'react';
import { Markup } from 'interweave';

 
const DetailCard = (props) => { 
       return (
        <div className='det-card'>
            <div className='det-card-content'>
            <Markup content={props.content} />
                     
              </div>
        </div>
 
       );
};

export default DetailCard;  